import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        backgroundColor: theme.palette.common.white
    },
    input: {
        marginTop: '16px'
    },
    info_header: {
        display: 'flex',
        gap: '12px',
        padding: '14px 16px',
        backgroundColor: theme.palette.success.light + '1A',
        border: `1px solid ${theme.palette.success.light}`,
        borderRadius: '8px',
    },
    info_icon_wrapper: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: theme.palette.success.light,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginTop: '1px',
    },
    info_icon: {
        fontSize: '16px',
        color: theme.palette.success.main,
        fontWeight: 600,
    },
    info_content: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    info_title: {
        fontSize: '14px',
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    info_description: {
        fontSize: '13px',
        color: theme.palette.text.secondary,
        lineHeight: 1.5,
    },
    info_difference: {
        fontWeight: 600,
        color: theme.palette.success.dark,
    },
    info_difference_negative: {
        color: theme.palette.error.main,
    },
    list_header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '12px',
    },
    list_title: {
        fontSize: '14px',
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    count_badge: {
        fontSize: '12px',
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.grey[100],
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '20px',
        padding: '2px 10px',
    },
    prices_list: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        maxHeight: '300px',
        overflowY: 'auto',
        paddingRight: '4px',

        '&::-webkit-scrollbar': {
            width: '6px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: theme.palette.grey[200],
            borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.grey[400],
            borderRadius: '3px',
            '&:hover': {
                backgroundColor: theme.palette.grey[600],
            },
        },
    },
    price_row: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '10px 12px',
        backgroundColor: theme.palette.grey[50],
        borderRadius: '6px',
        border: `1px solid ${theme.palette.grey[200]}`,
        transition: 'all 0.2s ease',

        '&:hover': {
            backgroundColor: theme.palette.grey[100],
            borderColor: theme.palette.grey[300],
        },
    },
    price_row_disabled: {
        opacity: 0.5,
        backgroundColor: theme.palette.grey[100],
    },
    agency_info: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        flex: 1,
        minWidth: 0,
    },
    agency_name: {
        fontSize: '13px',
        fontWeight: 500,
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    agency_label: {
        fontSize: '11px',
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
    },
    price_change: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '13px',
        fontWeight: 500,
        flexShrink: 0,
    },
    old_price: {
        color: theme.palette.text.secondary,
        textDecoration: 'line-through',
    },
    new_price: {
        color: theme.palette.success.dark,
        fontWeight: 600,
    },
    arrow: {
        color: theme.palette.text.disabled,
        fontSize: '14px',
    },
    checkbox_container: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0 0',
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        marginTop: '10px',
    },
    footer_note: {
        fontSize: '12px',
        color: theme.palette.text.disabled,
    },
    footer_count: {
        fontSize: '12px',
        color: theme.palette.text.secondary,
        fontWeight: 500,
    },
    empty_state: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    empty_state_icon: {
        fontSize: '40px',
        marginBottom: '12px',
        opacity: 0.5,
    },
    empty_state_text: {
        fontSize: '14px',
    },
    btn_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
        marginTop: '16px',
    }
}));

export { useStyles };